import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import { UserAddress } from '@chegg/user-address';
import { getZipFieldConfigs } from './utils/getZipFieldConfigs';
import { getLocalizedCountryFieldConfigs } from './utils/getCountryFieldConfigs';
import { useAppSelector } from '../../hooks/useAppSelector';
import { callback as _callback } from './utils/UserAddressCallback';
import { useDispatch } from 'react-redux';
import { isEmpty } from '@chegg/utils';
import { clearUserAddressCommands } from '../../redux/CommandState/CommandState.actions';
import { getAddressInfo } from './utils/getAddressInfo';
import { editableMopSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { userAddressCommandSelector } from '../../redux/CommandState/CommandState.selectors';
import { getCityFieldConfigs } from './utils/getCityFieldConfigs';
var UserAddressComponent = function UserAddressComponent(props) {
  var config = useAppSelector(configSelector);
  var editableMop = useAppSelector(editableMopSelector);
  var UserAddressCommand = useAppSelector(userAddressCommandSelector);
  var dispatch = useDispatch();
  var thirdPartyBraintreePayload = props.thirdPartyBraintreePayload,
    _props$isUpi = props.isUpi,
    isUpi = _props$isUpi === void 0 ? false : _props$isUpi,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;

  // when this variable is set using useState, it acts dicy with safari and applepay. Investigate.
  var dispatchAddressUpdate = false;
  useEffect(function () {
    if (!isEmpty(UserAddressCommand)) {
      dispatch(clearUserAddressCommands());
    }
  }, [UserAddressCommand]);
  var authorization = config.authorization,
    country = config.country,
    mandatoryCountries = config.mandatoryCountries,
    debug = config.debug,
    rioNamespace = config.rioNamespace,
    paymentForm = config.paymentForm,
    paymentErrorModal = config.paymentErrorModal,
    hiddenCountries = config.hiddenCountries,
    regexValidation = config.regexValidation,
    ui = config.ui,
    appConstants = config.appConstants;
  var verifyAddress = getAddressInfo(country, editableMop, thirdPartyBraintreePayload);
  if (!thirdPartyBraintreePayload) {
    dispatchAddressUpdate = true;
  }
  var uaConfig = _objectSpread(_objectSpread({
    authorization: authorization,
    stepInvoke: true,
    defaultCountryCode: country,
    formType: 'minimal',
    mandatoryCountries: mandatoryCountries,
    verifyAddress: verifyAddress,
    hiddenCountries: hiddenCountries,
    regexValidation: regexValidation,
    ui: ui,
    appConstants: appConstants,
    rioNamespace: rioNamespace,
    zipField: getZipFieldConfigs(paymentForm, paymentErrorModal, isUpi),
    localizedCountryField: getLocalizedCountryFieldConfigs(paymentForm, paymentErrorModal),
    cityField: getCityFieldConfigs(paymentForm, paymentErrorModal)
  }, debug && {
    debug: debug
  }), {}, {
    isUpi: isUpi,
    inputDisabled: disabled
  });
  if (isUpi) {
    uaConfig.defaultCountryCode = 'IN';
  }
  return /*#__PURE__*/React.createElement(UserAddress, {
    "data-test": 'user-address',
    config: uaConfig,
    callback: function callback(callbackPayload) {
      return _callback({
        callbackPayload: callbackPayload,
        dispatchAddressUpdate: dispatchAddressUpdate,
        dispatch: dispatch,
        ui: ui,
        paymentForm: paymentForm,
        paymentErrorModal: paymentErrorModal
      });
    },
    commands: UserAddressCommand,
    update: {
      config: {
        verifyAddress: verifyAddress
      }
    }
  });
};
export default /*#__PURE__*/React.memo(UserAddressComponent);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/index.js
// module id = 659
// module chunks = 11